/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListDemandesValidationFilterDto } from './ListDemandesValidationFilterDto';
import {
    ListDemandesValidationFilterDtoFromJSON,
    ListDemandesValidationFilterDtoFromJSONTyped,
    ListDemandesValidationFilterDtoToJSON,
    ListDemandesValidationFilterDtoToJSONTyped,
} from './ListDemandesValidationFilterDto';

/**
 * Generic list command (common/GetGenericListCommandDto) specialised with the typed filter of the validator inbox.
 * 
 * @export
 * @interface ListDemandesValidationCommand
 */
export interface ListDemandesValidationCommand {
    /**
     * Search string (maximum 100 characters)
     * @type {string}
     * @memberof ListDemandesValidationCommand
     */
    searchString?: string;
    /**
     * 
     * @type {number}
     * @memberof ListDemandesValidationCommand
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof ListDemandesValidationCommand
     */
    pageSize: number;
    /**
     * Column sort key: date (default, request date) | status | identifier | branch | tunnel | broker | subscriber | clientPrice. Omitted or unknown -> default sort.
     * 
     * @type {string}
     * @memberof ListDemandesValidationCommand
     */
    sortBy?: string;
    /**
     * "asc" or "desc" (default: desc)
     * @type {string}
     * @memberof ListDemandesValidationCommand
     */
    sortDirection?: string;
    /**
     * 
     * @type {ListDemandesValidationFilterDto}
     * @memberof ListDemandesValidationCommand
     */
    filters?: ListDemandesValidationFilterDto;
}

/**
 * Check if a given object implements the ListDemandesValidationCommand interface.
 */
export function instanceOfListDemandesValidationCommand(value: object): value is ListDemandesValidationCommand {
    if (!('pageNumber' in value) || value['pageNumber'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    return true;
}

export function ListDemandesValidationCommandFromJSON(json: any): ListDemandesValidationCommand {
    return ListDemandesValidationCommandFromJSONTyped(json, false);
}

export function ListDemandesValidationCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDemandesValidationCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'searchString': json['searchString'] == null ? undefined : json['searchString'],
        'pageNumber': json['pageNumber'],
        'pageSize': json['pageSize'],
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'sortDirection': json['sortDirection'] == null ? undefined : json['sortDirection'],
        'filters': json['filters'] == null ? undefined : ListDemandesValidationFilterDtoFromJSON(json['filters']),
    };
}

export function ListDemandesValidationCommandToJSON(json: any): ListDemandesValidationCommand {
    return ListDemandesValidationCommandToJSONTyped(json, false);
}

export function ListDemandesValidationCommandToJSONTyped(value?: ListDemandesValidationCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchString': value['searchString'],
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'sortBy': value['sortBy'],
        'sortDirection': value['sortDirection'],
        'filters': ListDemandesValidationFilterDtoToJSON(value['filters']),
    };
}

